import React from "react";
import Image from "../components/elements/Image";
import { Link } from "react-router-dom";
import Input from "../components/form/Input";
import Button from "../components/form/Button";

const FrontFooter = () => {
  const footerLinks = [
    {
      id: 1,
      title: "Company",
      links: [
        { name: "About", path: "/about" },
        { name: "Testimonials", path: "/testimonials" },
        { name: "Careers", path: "/careers" },
        { name: "Blogs", path: "/blogs" },
        { name: "Helps", path: "/helps" },
      ],
    },
    {
      id: 2,
      title: "Sell",
      links: [
        { name: "Bitcoin", path: "/" },
        { name: "Ethereum", path: "/" },
        { name: "XRP", path: "/" },
        { name: "Tether USDt", path: "/" },
        { name: "BNB", path: "/" },
      ],
    },
    {
      id: 3,
      title: "Buy",
      links: [
        { name: "Solana", path: "/" },
        { name: "USDC", path: "/" },
        { name: "TRON", path: "/" },
        { name: "Dogecoin", path: "/" },
        { name: "Cardano", path: "/" },
      ],
    },
    {
      id: 4,
      title: "Social Links",
      links: [
        { name: "Facebook", path: "https://facebook.com", icon: "fa-brands fa-facebook-f" },
        { name: "Instagram", path: "https://instagram.com", icon: "fa-brands fa-instagram" },
        { name: "Linkedin", path: "https://linkedin.com", icon: "fa-brands fa-linkedin-in" },
        { name: "Twitter", path: "https://twitter.com", icon: "fa-brands fa-twitter" },
      ],
    },
  ];


  return (
    <footer className="relative py-16 w-full mt-auto bg-footerBgGrey border-t border-FooterBorderGreen z-20">
      <div className="w-full max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
        <div className="bg-bgSubscribe rounded-xl py-6 px-16 mb-20">
          <div className="grid grid-cols-12 gap-10">
            <div className="col-span-7">
                <div className="flex gap-10 items-center">
                  <div className="text-white text-4xl">
                    <span><i className="fa-solid fa-envelope"></i></span>
                  </div>
                  <div className="text-white capitalize font-Poppins">
                    <h2 className="font-bold text-[32px]">Stay Informed - <span className="text-primary">Subscribe Now</span></h2>
                    <h3 className="font-Poppins text-lg">Stay updated with crypto news and tips.</h3>
                  </div>
                </div>
              </div>
              <div className="col-span-5 flex items-center">
                <div className="flex gap-2 w-full">
                  <Input
                    inputPlaceholder={"Enter Your Email"}
                    inputClasses={"!max-w-[500px] !h-14 rounded-xl placeholder:text-[#C5C5C5] text-black text-[16px] font-Inter"}
                  />
                  <div className="flex-shrink-0">
                    <Button
                      buttonLabel={"Subscribe"}
                      buttonClasses={"px-9 py-5 uppercase rounded-xl border"}
                    />
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-3 space-y-5">
            <Link to={"/"} className="w-28 aspect-square overflow-hidden block h-10">
              <Image
                src={require("../assets/image/footer-logo.png")}
                classes={"object-contain"}
              />
            </Link>
            <div className="font-Poppins text-base text-white">Trihurst enables secure, transparent, borderless transactions, giving individuals full control over their finances.</div>
            <div className="text-textCopyright font-Inter text-sm !mt-10">
              ©Copyright 2025, All Rights Reserved by Crupto
            </div>
          </div>
          <div className="col-span-9">
            <div className="flex flex-col">
            <div className="grid grid-cols-12 gap-10">
                {footerLinks.map((section) => (
                  <div key={section.id} className="col-span-3">
                    <div className="flex flex-col">
                      <div className="text-xl uppercase font-normal text-white mb-5">
                        {section.title}
                      </div>
                      <ul className="flex flex-col gap-3">
                        {section.links.map((link, idx) => (
                          <li key={idx} className="relative">
                            {link.path.startsWith("http") ? (
                              <a
                                href={link.path}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-base text-white capitalize transition-all duration-300 hover:translate-x-4 flex items-center gap-4"
                              >
                                {link.icon && <i className={`${link.icon} text-xs bg-white w-6 h-6 rounded-full text-black flex items-center justify-center font-light`}></i>}
                                {link.name}
                              </a>
                            ) : (
                              <Link
                                to={link.path}
                                className="inline-block text-base text-white capitalize transition-all duration-300 hover:translate-x-4"
                                >
                                  {link.icon && <i className={`${link.icon} text-lg`}></i>}
                                {link.name}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
            </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;
